import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {useNavigate} from "react-router-dom";
import {AuthContext} from "../../../config/AuthContext";
import Login from "../../Login";
import {Content} from "antd/es/layout/layout";
import {Button, Card, Progress, Table, TableProps, Tag} from "antd";
import {GetJutgeProblemes} from "../../../dao/jutge/GetJutgeProblemes";
import {ColumnsType} from "antd/es/table";
import BbddColors from "../../../styles/BbddColors";
import {BiArrowFromLeft} from "react-icons/bi";
import AppSider from "../../bbdd/components/AppSider";
import {GetBbddProblemes} from "../../../dao/bbdd/GetBbddProblemes";

const Problemes = () => {
    const {isLoggedIn, userId, user, setBreadCrumb} = useContext(AuthContext);
    const navigate = useNavigate();
    const [dades, setDades] = useState<any[]>([]);
    const [pantalla, setPantalla] = useState(0);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (isLoggedIn) {
            setBreadCrumb([{nom: 'Home', nav: '/home'},
                {nom: 'bbdd', nav: '/database'},
                {nom: 'problemes', nav: '/database/problemes'}], true);
            checkDades();
        }
    }, []);

    async function checkDades() {
        setLoading(true);
        const data = await GetBbddProblemes(userId);
        setDades(data);
        //console.log(JSON.stringify(data));
        setLoading(false);
    }

    const columns: ColumnsType<any> = [
        {
            key: 'id',
            dataIndex: 'id',
            width: 15,
            responsive: ['lg'],
        },
        {
            key: 'nom',
            dataIndex: 'nom',
            width: 30,
        },
        {
            key: 'intents',
            dataIndex: 'intents',
            width: 30,
            render: (e, ele) => (
                <>
                    <Tag color={BbddColors.colors.color5}>Progrés: </Tag>{" "}<Progress
                    percent={ele.propis}
                    steps={8}
                    strokeColor={[BbddColors.colors.color6, BbddColors.colors.color6,
                        BbddColors.colors.color5, BbddColors.colors.color5,
                        BbddColors.colors.color4, BbddColors.colors.color4,
                        BbddColors.colors.color3, BbddColors.colors.color3]} />
                </>
            )
        },
        {
            key: 'progres',
            dataIndex: 'progres',
            width: 30,
            render: (e, ele) => (
                <>
                    <Tag color={BbddColors.colors.color5}>% Encerts: </Tag>{" "}<Progress
                    percent={Math.round((ele.encertats / ele.totals) * 100)}
                    steps={8}
                    strokeColor={[BbddColors.colors.color1, BbddColors.colors.color1,
                        BbddColors.colors.color2, BbddColors.colors.color2,
                        BbddColors.colors.color4, BbddColors.colors.color4,
                        BbddColors.colors.color5, BbddColors.colors.color5]} />
                </>
            )
        },
        {
            key: 'dificultat',
            dataIndex: 'dificultat',
            width: 30,
            render: (e, ele) => (
                <>
                    <Tag color={BbddColors.colors.color4}>{e}</Tag>
                </>
            ),
        },
        {
            key: 'actions',
            dataIndex: 'actions',
            width: 10,
            render: (e, ele) => (
                <>
                    <Button title={"Accedir"} onClick={() => navigate(`${ele.id}`)}
                            style={{backgroundColor: BbddColors.colors.color6}}><BiArrowFromLeft/></Button>
                </>
            ),
        },
    ];


    const tableProps: TableProps<any> = {
        loading
    };

    function setPnt(value: number) {
        setPantalla(value);
    }

    if (isLoggedIn) {
        return (
            <>
                <AppSider setPantalla={setPnt} currentVal={1}/>
                <Content style={{ padding: '24px', minHeight: 280, background: '#f8f9fb' }}>
                    <Card
                        bordered={false}
                        style={{
                            boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
                            background: '#fff',
                            borderRadius: '12px'
                        }}
                    >
                        <Table
                            showHeader={false}
                            size={"small"}
                            title={() => "PROBLEMES"}
                            {...tableProps}
                            bordered={false}
                            columns={columns}
                            dataSource={dades}
                            style={{
                                borderRadius: '12px',
                                overflow: 'hidden',
                                background: '#fff'
                            }}
                        />
                    </Card>
                </Content>
            </>
        );
    } else {
        return (
            <Login/>
        );
    }
};

export default Problemes;
